define("shared/components/shared/media-library", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts", "later/utils/constants", "later/utils/format-query"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking, _emberConcurrency, _emberConcurrencyTs, _constants, _formatQuery) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts",0,"later/utils/constants",0,"later/utils/format-query"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cLIB--board eLib--board cCM--mediaLibrary" data-test-id="media-library">
    <div class="cLIB--boardHeader__upload">
      <Shared::AssetUpload @dropDisabled={{true}} @location="post_modal" />
    </div>
    <div class="cLIB--scrollContainer" {{perfect-scroll this.scrollbarId}}>
      <div class="cLIB--boardList gd--sideLibrary--media_grid">
        <ol class="cLIB--boardListContainer fc-draggable-wrapper">
          {{#each this.orderedMediaItems as |item|}}
            <Shared::MediaItems::MediaItem @mediaItem={{item}} />
          {{/each}}
        </ol>
  
        {{#if this.displayLoadMore}}
          <Shared::Ui::Button
            @class="o--btn--lg o--btn--outline o--btn--block u--text--hl u--m__tb"
            @isDisabled={{this.isLoadingMore}}
            @promise={{this.loadMore}}
            @runningText={{t "shared_words.loading"}}
            @text={{if this.isLoadingMore (t "shared_words.loading") (t "shared_phrases.load_more")}}
            @variant="outline"
          />
        {{else}}
          <span class="o--btn--sm u--text--light o--btn--block u--m__tb__sm">
            {{t "shared_phrases.no_more"}}
          </span>
        {{/if}}
      </div>
    </div>
  </div>
  */
  {
    "id": "nNpJwx8a",
    "block": "[[[10,0],[14,0,\"cLIB--board eLib--board cCM--mediaLibrary\"],[14,\"data-test-id\",\"media-library\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cLIB--boardHeader__upload\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@dropDisabled\",\"@location\"],[true,\"post_modal\"]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[11,0],[24,0,\"cLIB--scrollContainer\"],[4,[38,1],[[30,0,[\"scrollbarId\"]]],null],[12],[1,\"\\n    \"],[10,0],[14,0,\"cLIB--boardList gd--sideLibrary--media_grid\"],[12],[1,\"\\n      \"],[10,\"ol\"],[14,0,\"cLIB--boardListContainer fc-draggable-wrapper\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"orderedMediaItems\"]]],null]],null],null,[[[1,\"          \"],[8,[39,4],null,[[\"@mediaItem\"],[[30,1]]],null],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"displayLoadMore\"]],[[[1,\"        \"],[8,[39,6],null,[[\"@class\",\"@isDisabled\",\"@promise\",\"@runningText\",\"@text\",\"@variant\"],[\"o--btn--lg o--btn--outline o--btn--block u--text--hl u--m__tb\",[30,0,[\"isLoadingMore\"]],[30,0,[\"loadMore\"]],[28,[37,7],[\"shared_words.loading\"],null],[52,[30,0,[\"isLoadingMore\"]],[28,[37,7],[\"shared_words.loading\"],null],[28,[37,7],[\"shared_phrases.load_more\"],null]],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"o--btn--sm u--text--light o--btn--block u--m__tb__sm\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"shared_phrases.no_more\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"item\"],false,[\"shared/asset-upload\",\"perfect-scroll\",\"each\",\"-track-array\",\"shared/media-items/media-item\",\"if\",\"shared/ui/button\",\"t\"]]",
    "moduleName": "shared/components/shared/media-library.hbs",
    "isStrictMode": false
  });

  let MediaLibraryComponent = (_dec = (0, _object.computed)('mediaItemQuery.{queries.@each.isLoadingMore,queryListStartQuery,queryListQuery}'), (_class = class MediaLibraryComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "mediaItemQuery", _descriptor4, this);

      _initializerDefineProperty(this, "store", _descriptor5, this);

      _initializerDefineProperty(this, "displayLoadMore", _descriptor6, this);

      (0, _emberConcurrencyTs.taskFor)(this.loadMore).perform();
    }

    get isLoadingMore() {
      return this.mediaItemQuery.isLoadingMore(this.queryListString);
    }

    get mediaItems() {
      return this.store.peekAll('media-item').filter(mediaItem => {
        return mediaItem.group.get('id') === this.auth.currentGroup.id;
      });
    }

    get imageMediaItems() {
      return this.mediaItems.filterBy('mediaType', 'image');
    }

    get orderedMediaItems() {
      if (this.args.filterImages) {
        return this.imageMediaItems.sortBy('createdTime').reverse();
      }

      return this.mediaItems.sortBy('createdTime').reverse();
    }

    get queryListParams() {
      return {
        groupId: this.auth.currentGroup.id,
        limit: _constants.MEDIA_ITEM_LOAD_LIMIT,
        loadMore: true
      };
    }

    get queryListString() {
      // Note: these are the default values used to load the calendar side library
      const queryLabelIds = [];
      const mediaNotesSearchString = '';
      const usedUnused = 'unused';
      const mediaTypeFilter = '';
      const querySocialProfileIds = [];
      const queryArray = (0, _formatQuery.buildQueryArray)(queryLabelIds, undefined, mediaNotesSearchString, usedUnused, mediaTypeFilter, querySocialProfileIds, this.auth.currentGroup.id);
      return (0, _formatQuery.queryListToString)(queryArray);
    }

    *loadMore() {
      try {
        yield this.mediaItemQuery.queryWithFilters(this.queryListParams);

        if (this.mediaItemQuery.isCompleted(this.queryListString)) {
          this.displayLoadMore = false;
        }
      } catch (error) {
        this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
          title: this.intl.t('alerts.calendar.side_library.load_more_failed.title')
        });
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "mediaItemQuery", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "displayLoadMore", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "isLoadingMore", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isLoadingMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadMore", [_emberConcurrency.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "loadMore"), _class.prototype)), _class));
  _exports.default = MediaLibraryComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaLibraryComponent);
});